import React from 'react';

import { InfoItem } from '@molecules';

import { pluralize } from '@utils';
import { FORM_FIELD } from './constant';

const Item = ({ module, previewImg, errors }) => {
  const description = pluralize(module.content[FORM_FIELD.LINKS.name]?.length, 'link');

  return (
    <InfoItem.WithError error={errors} size="large" image={previewImg} description={description}>
      Social Media Links
    </InfoItem.WithError>
  );
};

export default Item;
